import React from 'react';
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ImageIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ImageUploaderProps {
  onImageSelect: (file: File) => void;
  imagePreview?: string;
}

export const ImageUploader = ({ onImageSelect, imagePreview }: ImageUploaderProps) => {
  const { t } = useTranslation();
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const handleImageSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onImageSelect(file);
    }
  };

  return (
    <div className="grid gap-2">
      <Label>{t('common.attachImage')}</Label>
      <div className="flex gap-2">
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleImageSelect}
          accept="image/*"
          className="hidden"
        />
        <Button
          type="button"
          variant="outline"
          onClick={() => fileInputRef.current?.click()}
          className="w-full"
        >
          <ImageIcon className="h-4 w-4 mr-2" />
          {t('common.selectImage')}
        </Button>
      </div>
      {imagePreview && (
        <div className="mt-2">
          <img
            src={imagePreview}
            alt="Preview"
            className="max-h-[200px] rounded-md object-cover"
          />
        </div>
      )}
    </div>
  );
};